import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';

import { TAB_EVENTS } from '@hooks/useOrganizationTabs';

import AppDetails from './App/Details';
import Details from './Details';
import List from './List';

const OrganizationRoutes = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <List />;
  }

  return (
    <Routes>
      <Route path="apps/:appId" element={<AppDetails />} />
      <Route path=":tab" element={<Details />} />
      <Route path="*" element={<Navigate to={TAB_EVENTS} replace />} />
    </Routes>
  );
};

export default OrganizationRoutes;
